import { BentoGrid } from "@/components/ui/bento-grid";
import { Button } from "@/components/ui/button";
import {
  CheckCircle,
  TrendingUp,
  Search,
  LayoutDashboard,
  ArrowRight,
} from "lucide-react";
import {
  Section,
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionDescription,
  SectionContent,
} from "@/components/ui/section";

const items = [
  {
    title: "Blazing-Fast Performance",
    description:
      "Experience ultra-fast load times with cutting-edge technologies and best practices.",
    icon: <TrendingUp />,
    color: "blue",
    tags: ["Speed", "Optimization", "AI"],
    colSpan: 2,
    hasPersistentHover: true,
  },
  {
    title: "Seamless Responsiveness",
    description:
      "Flawless user experience across all devices, from mobile to desktop.",
    icon: <CheckCircle />,
    color: "green",
    tags: ["User Experience", "Mobile First"],
    colSpan: 3,
  },
  {
    title: "Advanced SEO Optimization",
    description:
      "Built-in SEO strategies to improve visibility and drive more traffic.",
    icon: <Search />,
    color: "purple",
    tags: ["Search Engines", "Growth"],
    colSpan: 3,
  },
  {
    title: "Effortless Content Management",
    description: "Easy-to-use CMS integration for seamless content updates.",
    icon: <LayoutDashboard />,
    color: "pink",
    tags: ["CMS", "Automation"],
    colSpan: 2,
  },
];

function Features() {
  return (
    <Section id="features">
      <SectionContainer>
        <SectionHeader>
          <SectionTitle>Benefits</SectionTitle>
          <SectionDescription>
            We craft high-performance, visually stunning websites tailored to
            your business needs.
          </SectionDescription>
          <Button asChild size="lg" className="group">
            <a href="#contact" className="inline-flex items-center gap-2">
              Let's Build Something Great
              <ArrowRight
                className="-me-2 ms-0 transition-transform group-hover:translate-x-0.5"
                size={16}
                strokeWidth={2}
                aria-hidden="true"
              />
            </a>
          </Button>
        </SectionHeader>
        <SectionContent>
          <BentoGrid items={items} variant="default" columns={5} />
        </SectionContent>
      </SectionContainer>
    </Section>
  );
}

export default Features;
